<template>
  <!-- 底部按钮 -->
  <div class="v-m-start-time">
    <div v-if="typeTime == 'signUpStartTime'">
      {{ actStartTime.month }}<span>月</span>{{ actStartTime.day
      }}<span>日</span> {{ actStartTime.hours }}:{{ actStartTime.minutes }}
    </div>
    <div v-else>
      {{ startTime.month }}<span>月</span>{{ startTime.day }}<span>日</span>
      {{ startTime.hours }}:{{ startTime.minutes }}
    </div>
  </div>
</template>

<script>
import { formatDate } from "@utils/utils";

export default {
  name: "VMStartTime",

  data() {
    return {};
  },
  components: {},

  props: {
    superInfo: {
      type: Object,
      default: () => {},
    },
    typeTime: {
      type: String,
      default: () => "",
    },
  },
  computed: {
    // 开奖时间
    startTime() {
      const { drawStartTime } = this.superInfo;
      return formatDate(drawStartTime, "mmddhhmm");
    },
    // 活动开始时间
    actStartTime() {
      const { signUpStartTime } = this.superInfo;
      return formatDate(signUpStartTime, "mmddhhmm");
    },
  },
};
</script>
